import { createBannedWord, deleteBannedWord, getBannedWords, updateBannedWord } from "../../api/bannedWord";

const bannedWord = {
    namespaced: true,
    state: {
        bannedWords: {
            total: 0,
            data: [],
        },
    },
    mutations: {
        SET_BANNED_WORDS: (state, payload) => {
            state.bannedWords = payload;
        },
    },
    actions: {
        getBannedWords({ commit }, payload) {
            return getBannedWords(payload.perPage, payload.page).then((response) => {
                commit("SET_BANNED_WORDS", response.data);
                return response.data;
            });
        },
        getBannedWordPagination({ commit }, payload) {
            return getBannedWords(payload.perPage, payload.page);
        },
        getBannedWord({ state }, id) {
            return state.bannedWords.data.find((p) => p._id === id);
        },
        createBannedWord({ commit }, payload) {
            return createBannedWord(payload);
        },
        updateBannedWord({ commit }, payload) {
            return updateBannedWord(payload._id, payload);
        },
        deleteBannedWord({ commit }, id) {
            return deleteBannedWord(id);
        },
    },
};

export default bannedWord;
